import { render, staticRenderFns } from "./Modal.vue?vue&type=template&id=2801766a&scoped=true"
import script from "./Modal.vue?vue&type=script&lang=js"
export * from "./Modal.vue?vue&type=script&lang=js"
import style0 from "./Modal.vue?vue&type=style&index=0&id=2801766a&prod&lang=scss&scoped=true"
import style1 from "./Modal.vue?vue&type=style&index=1&id=2801766a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2801766a",
  null
  
)

export default component.exports